<template>
  <div class="row toc">
    <div class="col-md-12">
      <div class="button">
        <button class="btn btn-default btn-block-" style="float:left" @click="change_state()" v-html="button_text"></button>
      </div>
    </div>

    <div class="col-md-12">
      <transition name="slide-fade">
      <div class="content" v-if="show">
        <ul>
          <TableOfContentsItem
            v-for="item in categories"
            v-bind:c="item"
            v-bind:key="item.id">
          </TableOfContentsItem>
        </ul>
      </div>
      </transition>
    </div>

  </div>
</template>

<script>
import TableOfContentsItem from './TableOfContentsItem.vue'
export default {
  components: {
    TableOfContentsItem
  },
  name: 'TableOfContents',
  data () {
    return {
      show: true,
    }
  },
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  methods: {
    change_state() {
      this.show = !this.show;
    },
  },
  computed: {
    button_text() {
      return (this.show) ? '<i class="fa fa-eye-slash" aria-hidden="true"></i> '+this.$t('message.table_of_contents') : '<i class="fa fa-align-left" aria-hidden="true"></i> '+this.$t('message.table_of_contents');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.toc {
  padding: 0 0 30px 0;
  @media(min-width: 576px) {
    padding: 0 30px 30px 30px;
  }
  .button {
    text-align: right;
  }
  .content {
    background: #fff;
    border: 1px solid #ddd;
    padding: 15px;
    margin-top: 15px;
  }
  ul {
    padding: 0;
  }
}
 .label {
    font-size: .8em;
    text-align: center;
    padding: 15px 0 0;
    color: #5f5f5f;
    @media(min-width: 576px) {
      font-size: 1em;
    }
  }
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .35s ease;
}
.slide-fade-leave-active {
  transition: all .35s cubic-bezier(.2, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TableOfContents/TableOfContents.vue